// src/pages/AdFilms.js
import React from 'react';
import '../../styles/AdFilms.scss'; // Import SCSS

const CinematicFilms = () => (
  <div className="ad-films-container">
    <section className="hero-section">
      <h1 className="hero-title">Cinematics</h1>
      <p className="hero-description">Watch our latest Cinematics films that showcase our creativity and storytelling through engaging videos.</p>
    </section>
    <section className="videos-section">
    <div className="video-item">
  <h2 className="video-title">Dinesh + Bavleen</h2>
  <iframe
    src="https://www.youtube.com/embed/Vt9bGKsW4ys"
    title="New Video 1"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
    className="video-iframe"
  ></iframe>
</div>

<div className="video-item">
  <h2 className="video-title">Shilpa + Puneet</h2>
  <iframe
    src="https://www.youtube.com/embed/ULmAg8-Zny0"
    title="New Video 2"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
    className="video-iframe"
  ></iframe>
</div>

<div className="video-item">
  <h2 className="video-title">Rhea Sarkaria's Graduation</h2>
  <iframe
    src="https://www.youtube.com/embed/jtis3y-kFBI"
    title="New Video 3"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
    className="video-iframe"
  ></iframe>
</div>
      <div className="video-item">
        <h2 className="video-title">Shivani + Abhinav</h2>
        <iframe
          src="https://www.youtube.com/embed/r0UpXVQ5Ud4"
          title="Shivani + AbhinavFilm"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Veenu + Jannu</h2>
        <iframe
          src="https://www.youtube.com/embed/D87qiP9ZCsY"
          title="Veenu + Jannu"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Vikram + Dupinder</h2>
        <iframe
          src="https://www.youtube.com/embed/77h5QwAx8jo"
          title="Vikram + Dupinder"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Amarjeet + Harpreet</h2>
        <iframe
          src="https://www.youtube.com/embed/w4vonMvD6sE"
          title="Amarjeet + Harpreet"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Tanvir + Harmanjot</h2>
        <iframe
          src="https://www.youtube.com/embed/nXpBrERgfOs"
          title="Tanvir + Harmanjot"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Navjot + Balvinder</h2>
        <iframe
          src="https://www.youtube.com/embed/KzDTLPTOH20"
          title="Navjot + Balvinder"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Shivani + Ankur</h2>
        <iframe
          src="https://www.youtube.com/embed/mkUBKyJfJks"
          title="Shivani + Ankur"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Aditya + Aarti</h2>
        <iframe
          src="https://www.youtube.com/embed/jkgDkqlcRsM"
          title="Aditya + Aarti"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">Gurwinder + Navneet</h2>
        <iframe
          src="https://www.youtube.com/embed/c8HyudRgfpY"
          title="Gold Gym Ad Film"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
      <div className="video-item">
        <h2 className="video-title">HOTEL CLARKS INN</h2>
        <iframe
          src="https://www.youtube.com/embed/oGbMcsudLWo"
          title="Hotel Clarks Inn Ad Film"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="video-iframe"
        ></iframe>
      </div>
    </section>
  </div>
);

export default CinematicFilms;
